export const AI_CONNECTOR_CAPABILITY = 'ai-connector'

const KNOWN_HOSTS = { 'claude.ai': 'Claude', 'chatgpt.com': 'ChatGPT' }

export const hasAiConnector = user => Boolean(user?.attributes?.capabilities?.includes(AI_CONNECTOR_CAPABILITY))

export const appLabel = connection => {
  const host = connection?.attributes?.client_host
  return KNOWN_HOSTS[host] ?? connection?.attributes?.app_name ?? host ?? 'Unknown app'
}
